import React from 'react';
import {
  Box,
  Card,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatedDate(value) {
  let date = new Date(value);
  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.toLocaleString('default', { year: 'numeric' });
  return day + '-' + month + '-' + year;
}

class SalesTopList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      sx_hidden: { display: 'none' },
      value: "1",
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {};

    let data = BackofficeReportsApi.getSalesTop(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  }

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let locationSalesData = [];
    let locationSalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.top) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.top).forEach(key => {
          let fData = this.state.saleslocation_list.top[key];

          let myData = {
            x: fData.location,
            y: (parseInt(fData.value / 1000) + "K")
          };

          let p = {
            id: counter + 1,
            name: fData.location,
            date: formatedDate(fData.date),
            value: thousandsSeparator(parseInt(fData.value)),
            transactions: thousandsSeparator(parseInt(fData.transactions))
          };

          if (counter < 10) {
            locationSalesData.push(myData);
          }

          counter += 1;
          locationSalesList.push(p);
        });
      }
    }

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: '100%',
      width: '100%',
      tableLayout: {
        xs: 'fixed',
        md: 'auto'
      },
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.8rem',
          sm: '0.88rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.55,
        sm: 0.85,
      },
      px: {
        xs: 0.4,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.8,
      },
      px: {
        xs: 0.4,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <Paper
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: '100%',
          },
          maxHeight: {
            xs: 600,
            sm: '100%',
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Card
          sx={{
            height: '100%',
            minHeight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              px: {
                xs: 0.75,
                sm: 1,
              },
              py: {
                xs: 0.65,
                sm: 0.85,
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              flexShrink: 0,
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Top Sales Days
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Best sales days by location
              </Typography>
            </Box>

            <Typography
              sx={{
                flexShrink: 0,
                color: '#1a237e',
                bgcolor: 'rgba(26, 35, 126, 0.08)',
                border: '1px solid rgba(26, 35, 126, 0.12)',
                borderRadius: 999,
                px: 1,
                py: 0.35,
                fontWeight: 800,
                fontSize: {
                  xs: '0.72rem',
                  sm: '0.78rem',
                },
                lineHeight: 1.2,
              }}
            >
              {locationSalesList.length} rows
            </Typography>
          </Box>

          <TableContainer sx={tableContainerSx}>
            <Table stickyHeader aria-label="top sales table" sx={tableSx}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '24%',
                        sm: '22%',
                      },
                    }}
                  >
                    Date
                  </TableCell>

                  <TableCell
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '36%',
                        sm: '38%',
                      },
                    }}
                  >
                    Location
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '23%',
                        sm: '22%',
                      },
                    }}
                  >
                    Value
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '17%',
                        sm: '18%',
                      },
                    }}
                  >
                    Trans.
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? locationSalesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : locationSalesList
                ).map((location) => {
                  return (
                    <TableRow hover key={location.id} tabIndex={-1}>
                      <TableCell
                        sx={{
                          ...bodyCellSx,
                          color: '#475569',
                          fontWeight: 550,
                          fontSize: {
                            xs: '0.76rem',
                            sm: '0.88rem',
                          },
                        }}
                      >
                        {location.date}
                      </TableCell>

                      <TableCell
                        sx={{
                          ...bodyCellSx,
                          fontWeight: 550,
                          fontSize: {
                            xs: '0.78rem',
                            sm: '0.88rem',
                          },
                        }}
                      >
                        {location.name}
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          ...bodyCellSx,
                          fontVariantNumeric: 'tabular-nums',
                          fontWeight: 650,
                          fontSize: {
                            xs: '0.78rem',
                            sm: '0.88rem',
                          },
                        }}
                      >
                        {location.value}
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          ...bodyCellSx,
                          fontVariantNumeric: 'tabular-nums',
                          fontSize: {
                            xs: '0.78rem',
                            sm: '0.88rem',
                          },
                        }}
                      >
                        {location.transactions}
                      </TableCell>
                    </TableRow>
                  );
                })}

                {locationSalesList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Box
                        sx={{
                          py: 4,
                          color: 'text.secondary',
                          fontSize: {
                            xs: '0.86rem',
                            sm: '0.92rem',
                          },
                        }}
                      >
                        No data
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[14, { value: -1, label: 'All' }]}
            labelRowsPerPage="Rows:"
            component="div"
            count={locationSalesList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            sx={paginationSx}
          />
        </Card>
      </Paper>
    );
  }
}

export default SalesTopList;
